import { HolderOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Card, Flex, Input, Space, Switch, Typography } from 'antd';
import { DndContext, PointerSensor, closestCenter, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable';

const { Search } = Input;
const { Text } = Typography;

const SortableCard = ({ record, editCategory, deleteCategory, toggleVisible }) => {
  const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging } = useSortable({
    id: String(record.id),
  });

  const style = {
    transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
    transition,
    ...(isDragging ? { position: 'relative', zIndex: 9999 } : {}),
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes}>
      <Card styles={{ body: { padding: 12 } }}>
        <Flex justify='space-between' align='center' gap={8}>
          <HolderOutlined
            ref={setActivatorNodeRef}
            style={{ cursor: 'grab', touchAction: 'none', fontSize: 18, color: '#bbb', flexShrink: 0 }}
            {...listeners}
          />
          <Text strong style={{ flex: 1, minWidth: 0 }} ellipsis={{ tooltip: record.name }}>
            {record.name}
          </Text>
          <Switch
            checked={!!record.is_visible}
            onChange={() => toggleVisible(record)}
            checkedChildren='Hiện'
            unCheckedChildren='Ẩn'
            size='small'
          />
        </Flex>

        <Flex justify='space-between' align='center' style={{ marginTop: 8 }}>
          <Text type='secondary' style={{ fontSize: 12 }}>
            {record.is_visible ? 'Hiển thị trên web' : 'Đang ẩn'}
          </Text>
          <Space size={4}>
            <Button size='small' icon={<EditOutlined />} onClick={() => editCategory(record.id)}>Sửa</Button>
            <Button size='small' danger icon={<DeleteOutlined />} onClick={() => deleteCategory(record.id)}>Xoá</Button>
          </Space>
        </Flex>
      </Card>
    </div>
  );
};

const CategoryMobile = ({ viewModel }) => {
  const { data, filter, setFilterValue, createCategory, editCategory, deleteCategory, toggleVisible, reorderItems } = viewModel;

  const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 6 } }));

  const handleDragEnd = ({ active, over }) => {
    if (!active || !over || active.id === over.id) return;
    reorderItems(String(active.id), String(over.id));
  };

  return (
    <Space direction='vertical' size={12} style={{ width: '100%' }}>
      <Card>
        <Space direction='vertical' size={8} style={{ width: '100%' }}>
          <Search
            placeholder='Tên danh mục...'
            onChange={(e) => setFilterValue('info', e.target.value)}
            value={filter.info}
            style={{ width: '100%' }}
            allowClear
          />
          <Flex justify='flex-end'>
            <Button type='primary' onClick={createCategory}>Thêm mới</Button>
          </Flex>
        </Space>
      </Card>

      {(data || []).length === 0 && (
        <Card style={{ textAlign: 'center' }}>
          <Text type='secondary'>Chưa có danh mục nào</Text>
        </Card>
      )}

      <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
        <SortableContext items={(data || []).map((r) => String(r.id))} strategy={verticalListSortingStrategy}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {(data || []).map((record) => (
              <SortableCard
                key={record.id}
                record={record}
                editCategory={editCategory}
                deleteCategory={deleteCategory}
                toggleVisible={toggleVisible}
              />
            ))}
          </div>
        </SortableContext>
      </DndContext>
    </Space>
  );
};

export default CategoryMobile;
